import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';

export interface BrowserInfo {
  name: BrowserName,
  version: string
}

export interface DeviceInfo {
  deviceType: DeviceType,
  OS: OSName,
  appVersion: string
}

export enum BrowserName {
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  Safari = 'Safari',
  Edge = 'Edge',
  Opera = 'Opera',
  Unknown = 'Unknown',
}

export enum DeviceType {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
  Tablet = 'Tablet',
}

export enum OSName {
  Unknown = 'Unknown OS',
  Windows = 'Windows',
  Mac = 'MacOS',
  Unix = 'UNIX',
  Linux = 'Linux',
  Android = 'Android',
  iOS = 'iOS',
}

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {

  constructor() { }

  getBrowserInfo(): BrowserInfo {
    const userAgent = navigator.userAgent;
    let browserName: BrowserName = BrowserName.Unknown;
    let browserVersion = 'Unknown';

    // Browser detection
    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = BrowserName.Chrome;
      browserVersion = userAgent.match(/chrom(?:e|ium|ios)\/(\d+)/i)?.[1] ?? 'Unknown';
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = BrowserName.Firefox;
      browserVersion = userAgent.match(/firefox\/(\d+)/i)?.[1] ?? 'Unknown';
    } else if (userAgent.match(/safari/i) && !userAgent.match(/chrome|chromium|crios/i)) {
      browserName = BrowserName.Safari;
      browserVersion = userAgent.match(/version\/(\d+)/i)?.[1] ?? 'Unknown';
    } else if (userAgent.match(/edg/i)) {
      browserName = BrowserName.Edge;
      browserVersion = userAgent.match(/edg\/(\d+)/i)?.[1] ?? 'Unknown';
    } else if (userAgent.match(/opr|opera/i)) {
      browserName = BrowserName.Opera;
      browserVersion = userAgent.match(/(?:opr|opera)\/(\d+)/i)?.[1] ?? 'Unknown';
    }

    return {
      name: browserName,
      version: browserVersion
    };
  }

  getDeviceInfo(): DeviceInfo {
    const ua = navigator.userAgent;
    let deviceType: DeviceType = DeviceType.Desktop; // Default to desktop

    // Simple mobile detection
    if (/mobile/i.test(ua)) {
      deviceType = DeviceType.Mobile;
    } else if (/tablet|ipad/i.test(ua)) {
      deviceType = DeviceType.Tablet;
    }

    // Operating system detection
    let os: OSName = OSName.Unknown;
    if (ua.indexOf('Win') != -1) os = OSName.Windows;
    if (ua.indexOf('Mac') != -1) os = OSName.Mac;
    if (ua.indexOf('X11') != -1) os = OSName.Unix;
    if (ua.indexOf('Linux') != -1) os = OSName.Linux;
    if (/android/i.test(ua)) os = OSName.Android;
    if (/ios|iphone|ipad|ipod/i.test(ua)) os = OSName.iOS;

    return {
      deviceType: deviceType,
      OS: os,
      appVersion: environment.APP_VERSION
    };
  }
}
